import { t, getLanguage } from './i18n.js';
import affiliateData from '../data/affiliates.json';
import { AffiliateService } from '../infrastructure/services/AffiliateService.js';

let currentCategoryFilter = 'all';

export function renderAffiliates(containerId) {
  const container = document.getElementById(containerId);
  if (!container) return;

  const currentLang = getLanguage();

  // 1. Top Pick High-Conversion Hero Banner
  const topPicks = [
    {
      partnerKey: 'airalo',
      tag: currentLang === 'zh' ? '🔥 必备第一名' : currentLang === 'ja' ? '🔥 必須No.1' : currentLang === 'en' ? '🔥 Must-Have #1' : '🔥 여행 필수 1위',
      title: currentLang === 'zh' ? '韩国 5G 无限流量 eSIM' : currentLang === 'ja' ? '韓国 5G 無制限 eSIM' : currentLang === 'en' ? 'Korea 5G Unlimited eSIM' : '한국 5G 초고속 무제한 eSIM',
      highlight: currentLang === 'zh' ? '落地即连 · 免排队 · 8折优惠' : currentLang === 'ja' ? '空港待ち時間0分 · 即時開通 20%OFF' : currentLang === 'en' ? 'Instant Activation · 20% OFF' : '공항 대기 0초 · 20% 즉시할인',
      cta: currentLang === 'zh' ? '立即特惠预订' : currentLang === 'ja' ? '最安値で予約' : currentLang === 'en' ? 'Book eSIM Now' : '⚡ 20% 할인 예약',
      badgeClass: 'badge-fire'
    },
    {
      partnerKey: 'kkday',
      tag: currentLang === 'zh' ? '⚡ 门票狂省40分' : currentLang === 'ja' ? '⚡ 待機列スキップ' : currentLang === 'en' ? '⚡ Skip The Line' : '⚡ 대기 40분 단축',
      title: currentLang === 'zh' ? '热门一日游 & 景点通票' : currentLang === 'ja' ? '人気ツアー＆観光パス' : currentLang === 'en' ? 'Day Tours & Attraction Passes' : '인기 투어 & 어트랙션 패스',
      highlight: currentLang === 'zh' ? '南怡岛/乐天世界/韩服体验' : currentLang === 'ja' ? '南怡島/ロッテワールド/韓服体験' : currentLang === 'en' ? 'Nami Island / Lotte World / Passes' : '남이섬 / 롯데월드 / 궁궐 패스트트랙',
      cta: currentLang === 'zh' ? '抢先预订' : currentLang === 'ja' ? 'チケットを予約' : currentLang === 'en' ? 'Book Tours' : '🎟️ 패스 특가 예약',
      badgeClass: 'badge-lightning'
    },
    {
      partnerKey: 'goodlugg',
      tag: currentLang === 'zh' ? '🧳 空手轻松游' : currentLang === 'ja' ? '🧳 手ぶら観光' : currentLang === 'en' ? '🧳 Hands-Free Travel' : '🧳 양손 가벼운 여행',
      title: currentLang === 'zh' ? '仁川/金浦机场 行李直达酒店' : currentLang === 'ja' ? '仁川・金浦空港 当日手荷物配送' : currentLang === 'en' ? 'Airport Luggage Delivery' : '공항 ↔ 호텔 당일 짐배송',
      highlight: currentLang === 'zh' ? '当天直达 · 免提行李逛街' : currentLang === 'ja' ? '当日配送 · 重い荷物から解放' : currentLang === 'en' ? 'Same-Day Delivery to Hotels' : '캐리어 없이 입국 즉시 바로 관광',
      cta: currentLang === 'zh' ? '申请行李配送' : currentLang === 'ja' ? '手荷物配送を予約' : currentLang === 'en' ? 'Book Delivery' : '🧳 짐배송 예약',
      badgeClass: 'badge-star'
    }
  ];

  const topPicksHtml = topPicks.map(pick => {
    const trackedUrl = AffiliateService.getTrackedUrl(pick.partnerKey, 'top_pick_banner');
    return `
      <div class="top-pick-card glass-panel">
        <div class="top-pick-tag ${pick.badgeClass}">${pick.tag}</div>
        <h4 class="top-pick-title">${pick.title}</h4>
        <p class="top-pick-highlight">${pick.highlight}</p>
        <a href="${trackedUrl}" target="_blank" rel="noopener noreferrer" class="btn-top-pick btn-affiliate" data-partner="${pick.partnerKey}">
          ${pick.cta} ➔
        </a>
      </div>
    `;
  }).join('');

  // 2. Filter tabs for buyer intent
  const categoryFilters = [
    { key: 'all', label: currentLang === 'zh' ? '全部特惠' : currentLang === 'ja' ? 'すべて' : currentLang === 'en' ? 'All Deals' : '전체 특가' },
    { key: 'sim', label: currentLang === 'zh' ? '📶 5G eSIM / 流量' : currentLang === 'ja' ? '📶 5G eSIM / 通信' : currentLang === 'en' ? '📶 5G eSIM & SIM' : '📶 5G 무제한 eSIM' },
    { key: 'pass', label: currentLang === 'zh' ? '🎟️ 门票 & 一日游' : currentLang === 'ja' ? '🎟️ ツアー＆パス' : currentLang === 'en' ? '🎟️ Tours & Passes' : '🎟️ 투어 & 입장권 패스' },
    { key: 'hotel', label: currentLang === 'zh' ? '🏨 酒店 & 住宿' : currentLang === 'ja' ? '🏨 ホテル＆宿泊' : currentLang === 'en' ? '🏨 Hotels & Stays' : '🏨 호텔 & 숙소 특가' },
    { key: 'luggage', label: currentLang === 'zh' ? '🧳 짐배송 / 짐보관' : currentLang === 'ja' ? '🧳 手荷物配送＆保管' : currentLang === 'en' ? '🧳 Luggage Delivery' : '🧳 짐배송 & 짐보관' },
    { key: 'transport', label: currentLang === 'zh' ? '✈️ 交通 & 机场接送' : currentLang === 'ja' ? '✈️ 交通＆空港送迎' : currentLang === 'en' ? '✈️ Airport Transfers' : '✈️ 항공 & 공항 픽업' }
  ];

  const filterTabsHtml = categoryFilters.map(filter => `
    <button class="deal-category-tab ${currentCategoryFilter === filter.key ? 'active' : ''}" data-cat="${filter.key}">
      ${filter.label}
    </button>
  `).join('');

  // 3. Filter partners
  const filteredGlobalPartners = affiliateData.globalPartners.filter(p => {
    if (currentCategoryFilter === 'all') return true;
    return p.category === currentCategoryFilter;
  });

  const globalCards = filteredGlobalPartners.map(partner => {
    const name = partner.name[currentLang] || partner.name.en || partner.name.ko;
    const badge = partner.badge[currentLang] || partner.badge.en || partner.badge.ko;
    const desc = partner.desc[currentLang] || partner.desc.en || partner.desc.ko;
    const cta = partner.ctaText[currentLang] || partner.ctaText.en || partner.ctaText.ko;
    const trackedUrl = AffiliateService.getTrackedUrl(partner.partnerKey, `ktour_deals_${currentCategoryFilter}`);

    return `
      <div class="affiliate-card glass-panel" data-id="${partner.id}">
        <div class="affiliate-card-header">
          <div class="affiliate-badge">${badge}</div>
          <div class="affiliate-rating">⭐ ${partner.rating} <span class="reviews">(${partner.reviews})</span></div>
        </div>
        <h3 class="affiliate-title">${name}</h3>
        <p class="affiliate-desc">${desc}</p>
        <div class="affiliate-card-footer">
          <a href="${trackedUrl}" target="_blank" rel="noopener noreferrer" class="btn btn-primary btn-affiliate" data-partner="${partner.partnerKey}">
            <span>${cta}</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
          </a>
        </div>
      </div>
    `;
  }).join('');

  const domesticCards = affiliateData.domesticPartners.map(partner => {
    return `
      <div class="affiliate-card domestic-card glass-panel" data-id="${partner.id}">
        <div class="affiliate-card-header">
          <div class="affiliate-badge badge-domestic">${partner.badge}</div>
        </div>
        <h3 class="affiliate-title">${partner.name}</h3>
        <p class="affiliate-desc">${partner.desc}</p>
        <div class="affiliate-card-footer">
          <a href="${partner.url}" ${partner.url.startsWith('http') ? 'target="_blank" rel="noopener noreferrer"' : 'data-action="stamp-modal"'} class="btn btn-secondary btn-affiliate">
            <span>${partner.ctaText}</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </a>
        </div>
      </div>
    `;
  }).join('');

  // 4. Honest Travel Tips Box (인사이트 7 & 보너스: 솔직한 여행 꿀팁)
  const tipTitle = currentLang === 'zh' ? '💡 韩国旅行省钱省时核心秘诀 (Editor\'s Real Tips)' : currentLang === 'ja' ? '💡 韓国旅行の時短＆節約リアルアドバイス (Editor\'s Tips)' : currentLang === 'en' ? '💡 Smart Korea Travel Hacks (Save Time & Money)' : '💡 스마트 한국 여행 실전 팁 (시간 절약 & 최저가)';
  const tip1 = currentLang === 'zh' ? '<strong>어트랙션 현장 구매 주의:</strong> 주요 명소(롯데월드, 남산타워 등) 현장 매표소는 평균 30~50분 대기가 발생합니다. 온라인 사전 모바일 QR 바우처로 대기 없이 바로 입장하세요.' : currentLang === 'ja' ? '<strong>現地購入の注意点:</strong> 主要アトラクション（ロッテワールド、Nソウルタワー等）の窓口は平均30〜50分並びます。事前QRバウチャー予約で並ばずスムーズに入場を！' : currentLang === 'en' ? '<strong>Skip the Ticket Queue:</strong> Waiting times at ticket booths can exceed 40 mins during peak hours. Pre-book mobile QR passes online for direct instant entry.' : '<strong>현장 매표소 대기 주의:</strong> 주요 어트랙션(롯데월드, N서울타워 등) 현장 매표소는 주말/성수기 30~50분 이상 줄을 섭니다. 온라인 사전 모바일 QR 예약으로 대기 없이 즉시 입장하세요.';
  const tip2 = currentLang === 'zh' ? '<strong>공항 데이터 이용 꿀팁:</strong> 공항 카운터에서 비싼 로밍이나 물리 유심을 찾지 마시고, 5G 무제한 eSIM을 미리 등록해 비행기 착륙 즉시 켜세요.' : currentLang === 'ja' ? '<strong>空港データ通信のコツ:</strong> 空港カウンターで並ぶ必要なし！無制限5G eSIMを事前にダウンロードしておけば着陸直後から即利用可能です。' : currentLang === 'en' ? '<strong>Airport Data Tip:</strong> Avoid long lines at airport SIM counters. Install a 5G unlimited eSIM in advance and get connected the moment your flight touches down.' : '<strong>공항 데이터 꿀팁:</strong> 입국장 카운터에서 줄 설 필요 없이, 5G 무제한 eSIM을 사전 등록해 비행기 착륙 즉시 바로 데이터를 켜세요.';

  container.innerHTML = `
    <div class="affiliates-section">
      <!-- Header -->
      <div class="section-header">
        <h2 class="section-title" data-i18n="globalDealsTitle">${t('globalDealsTitle')}</h2>
        <p class="section-subtitle" data-i18n="globalDealsSubtitle">${t('globalDealsSubtitle')}</p>
      </div>

      <!-- Top-Pick 3-Card Decision Fatigue Reducer -->
      <div class="top-picks-section">
        <div class="top-picks-header">
          <span class="top-picks-icon">💡</span>
          <div>
            <h3 class="top-picks-title">${currentLang === 'zh' ? '旅行者必选三大件 · 快速预约' : currentLang === 'ja' ? '韓国旅行の3大必須アイテム · スピード予約' : currentLang === 'en' ? 'Top 3 Essentials for Korea · Fast Booking' : '한국 여행자 3대 필수 원픽 패키지 · 빠른 예약'}</h3>
            <p class="top-picks-desc">${currentLang === 'zh' ? '减少选择焦虑，万千游客亲测好评的最高性价比精选' : currentLang === 'ja' ? '迷ったらコレ！1万人以上が選んだ最もお得な厳選プラン' : currentLang === 'en' ? 'Zero decision fatigue: Most-booked & top-rated items by global travelers' : '선택 고민 끝! 수만 명의 여행자가 검증한 최저가 & 인기 1위 원픽'}</p>
          </div>
        </div>
        <div class="top-picks-grid">
          ${topPicksHtml}
        </div>
      </div>

      <!-- Buyer Intent Category Filter Tabs -->
      <div class="deal-category-filter-bar">
        ${filterTabsHtml}
      </div>

      <!-- Main Affiliates Grid -->
      <div class="affiliates-grid">
        ${globalCards}
      </div>

      <!-- Honest Travel Tips Box -->
      <div class="honest-tips-card glass-panel">
        <div class="tips-card-header">
          <span class="tips-icon">✨</span>
          <h3 class="tips-title">${tipTitle}</h3>
        </div>
        <div class="tips-content">
          <div class="tip-item">
            <span class="tip-dot">✔</span>
            <p>${tip1}</p>
          </div>
          <div class="tip-item">
            <span class="tip-dot">✔</span>
            <p>${tip2}</p>
          </div>
        </div>
      </div>

      <!-- Domestic & Stamp Deals -->
      <div class="section-header mt-8">
        <h2 class="section-title">🇰🇷 국내 여행자 특별 제휴 & 스탬프 혜택</h2>
        <p class="section-subtitle">야놀자 숙소 특가, 마이리얼트립 로컬 투어, 지자체 스탬프투어 사은품 안내</p>
      </div>
      <div class="affiliates-grid">
        ${domesticCards}
      </div>
    </div>
  `;

  // Category filter click event listeners
  container.querySelectorAll('.deal-category-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      currentCategoryFilter = tab.dataset.cat;
      renderAffiliates(containerId);
    });
  });

  // Telemetry Click Listener
  container.querySelectorAll('.btn-affiliate').forEach(btn => {
    btn.addEventListener('click', () => {
      const pKey = btn.dataset.partner || 'general';
      AffiliateService.logAffiliateClick(pKey, `deals_tab_${currentCategoryFilter}`);
    });
  });
}

export function renderEmergency(containerId) {
  const container = document.getElementById(containerId);
  if (!container) return;

  const currentLang = getLanguage();

  const contactsHtml = affiliateData.emergencyContacts.map(c => {
    const name = c.name[currentLang] || c.name.en || c.name.ko;
    const desc = c.desc[currentLang] || c.desc.en || c.desc.ko;

    return `
      <div class="emergency-card glass-panel">
        <div class="emergency-info">
          <div class="emergency-icon-wrap">
            <span class="emergency-phone-badge">${c.phone}</span>
          </div>
          <div>
            <h3 class="emergency-name">${name}</h3>
            <p class="emergency-desc">${desc}</p>
          </div>
        </div>
        <div class="emergency-action">
          <a href="tel:${c.phone}" class="btn btn-emergency">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
            <span>${t('callPhone')} (${c.phone})</span>
          </a>
        </div>
      </div>
    `;
  }).join('');

  container.innerHTML = `
    <div class="emergency-section">
      <div class="section-header">
        <h2 class="section-title" data-i18n="emergencyTitle">${t('emergencyTitle')}</h2>
        <p class="section-subtitle" data-i18n="emergencySubtitle">${t('emergencySubtitle')}</p>
      </div>
      <div class="emergency-list">
        ${contactsHtml}
      </div>
    </div>
  `;
}
